import * as InternalUtils from "scriptsShared/Utils.js";
export default {
  name: "v-file-input",
  data: function data() {
    return {
      valueInternal: this.value
    };
  },
  computed: {},
  mounted: function mounted() {
    InternalUtils.AssignReactivePropWatches(this);
  },
  props: {
    value: {
      required: true,
      reactive: true
    },
    inputId: {
      type: String,
      required: false
    },
    accept: String
  }
};